var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "back_blue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5992",
    "data-name": "Rectangle 5992",
    width: 36,
    height: 36,
    rx: 4,
    fill: "#0074d7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_black_24dp_1_",
    "data-name": "arrow_back_black_24dp (1)",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M19,11H7.83l4.88-4.88a1.008,1.008,0,0,0,0-1.42,1,1,0,0,0-1.41,0L4.71,11.29a1,1,0,0,0,0,1.41l6.59,6.59a1,1,0,0,0,1.41-1.41L7.83,13H19a1,1,0,0,0,0-2Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlue);
export default __webpack_public_path__ + "static/media/back_blue.3ce51131176f590cec32c7de1f86c882.svg";
export { ForwardRef as ReactComponent };